(function ($) {
  $.fn.wsMenu = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            this.resizeMenu();
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      var opt = $.extend({
        delay: 100,
        speed: 10,
      }, options);

      // Elements
      let menuElement;
      let openButtonElement;
      let navDesktopTopLeft;
      let slidingMenuContainerElement;
      let slidingBarElement;
      let slidingMenuMainElement;
      let navDesktopBottom;
      let slidingMenuSubmenuElement;
      let slidingMenuSubmenuCloseElement;
      let slidingmenuSubmenuCloseTitleElement;
      let slidingMenuSubmenuHeaderElement;
      let slidingMenuSubmenuContentElement;
      let slidingMenuSubmenuTooManyItemsButtonTemplate;

      let slidingMenuSubSubmenuElement;
      let slidingMenuSubSubmenuCloseElement;
      let slidingmenuSubSubmenuCloseTitleElement;
      let slidingMenuSubSubmenuHeaderElement;
      let slidingMenuSubSubmenuContentElement;
      let slidingMenuSubSubmenuTooManyItemsButtonTemplate;

      // Variables
      //let hover = false;
      let slidingMenuOpen = false;
      let slidingSubMenuOpen = false;

      //let moveToX = 0;

      let bindEvents = function () {
        openButtonElement.click(open);

        navDesktopTopLeft.find('> div > ul > li > a').click(function ( event ) {
          event.preventDefault();
          navDesktopTopLeft.find('> div > ul > li').removeClass('current-menu-item current-menu-ancestor current-menu-parent');
          let parent = $(this).parent();
          parent.addClass('current-menu-item current-menu-ancestor current-menu-parent');
          switchNavDesktopBottom(parent);
        });

        bindNavDesktopBottomEvents();
        bindSubSubMenuEvents();

        slidingMenuSubmenuCloseElement.click(closeSub);
        slidingMenuSubSubmenuCloseElement.click(closeSubSub);
      }

      let bindNavDesktopBottomEvents = function () {
        navDesktopBottom.find('li a').each(function () {
          let el = $(this);
          let parent = el.parent();
          if (parent.find('.ws-submenu-wrapper').length === 0) {
            el.append('<i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></i>');
            return;
          }
          el.append('<i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg></i>');
          el.click(function (event) {

            event.preventDefault();
            openSub(parent);
          });
        });
      }

      let bindSubSubMenuEvents = function () {
        slidingMenuSubmenuContentElement.find('.ws-submenu-wrapper').find('.sub-menu li a').each(function () {
            let el = $(this);
            let parent = el.parent();
            if (parent.find('.ws-submenu-wrapper').length === 0) {
              return;
            }
            el.click(function ( event ) {
              event.preventDefault();

              $('html, body').animate({scrollTop: $('body').offset().top}, 500);

              setTimeout(function () {
                openSubSub(parent)
              }, 400);
            });
        });
      }


      // Resize.
      let resizeMenu = this.resizeMenu = function () {
        //menuElement.css('min-height', $(document).height() - menuElement.offset().top + 'px');

        if (slidingMenuOpen) {
          if(slidingSubMenuOpen) {
            slidingMenuContainerElement.height(slidingMenuSubSubmenuElement.height());
            slidingBarElement.css('transform', 'translateX(-100%)');
          } else {
            slidingMenuContainerElement.height(slidingMenuSubmenuElement.height());
            slidingBarElement.css('transform', 'translateX(-50%)');
          }
        } else {
          slidingMenuContainerElement.height(slidingMenuMainElement.height());
          slidingBarElement.css('transform', 'translateX(0)');
        }
      }

      let open = this.open = function () {
        //$('body').height(menuElement.height() + menuElement.offset().top).css('overflow', 'hidden');
        //$('html').css('overflow', 'auto');
        menuElement.toggleClass('open');
      };

      let switchNavDesktopBottom = function (item) {
        //item
        let itemSubmenu = item.find('> .ws-submenu-wrapper');
        navDesktopBottom.html(itemSubmenu.html());

        bindSubSubMenuEvents();
        bindNavDesktopBottomEvents();
        closeSub();
      };

      let openSub = function (item) {
        // Todo set header
        let headerName = navDesktopTopLeft
          .find('> div > ul > .current-menu-item > a, > div > ul > .current-menu-ancestor > a, > div > ul > .current-menu-parent > a')
          .text();
        let itemName = item.find('> a').html();
        let itemSubmenu = item.find('> .ws-submenu-wrapper');

        slidingMenuOpen = true;
        slidingSubMenuOpen = false;
        slidingBarElement.css('transform', 'translateX(-50%)');

        slidingMenuSubmenuContentElement.html(itemSubmenu.html());

        slidingMenuSubmenuContentElement.find('.ws-submenu-wrapper > ul').each(function () {
          // Check amount of items, if too many, add open/close button.
          let maxItems = 6;
          let el = $(this);
          let children = el.children();
          let tooMany = [];
          if (children.length > maxItems) {
            let title = el.parent().parent().find('> a');

            for (let i = maxItems; i < children.length; i++) {
              tooMany.push(children[i]);
            }

            $(tooMany).wrapAll('<div class="tooManyWrapper">');
            let tooManyWrapper = el.find('.tooManyWrapper');
            tooManyWrapper.get(0).style.setProperty('--ws-items-too-many', tooMany.length); // Set through basic JS, as jQuery won't let you do this.

            let tooManyItemsButton = slidingMenuSubmenuTooManyItemsButtonTemplate.clone();

            tooManyItemsButton.find('.title').html(title.html());

            tooManyItemsButton
              .click(function () {
                tooManyWrapper.toggleClass('open');
                $(this).toggleClass('open');
                //let interval = setInterval(resizeMenu, 10);
                //setTimeout(function () { clearInterval(interval); }, 5000);
                setTimeout(resizeMenu, 500);
              })
              .appendTo(el)
            ;
          }
        });


        slidingMenuSubmenuHeaderElement.html(itemName);
        slidingmenuSubmenuCloseTitleElement.html(headerName);

        bindSubSubMenuEvents();
        resizeMenu();
      };

      let openSubSub = function (item) {
        let headerName = slidingMenuSubmenuHeaderElement.text();

        let itemName = item.find('> a').html();
        let itemSubmenu = item.find('> .ws-submenu-wrapper');

        slidingMenuOpen = true;
        slidingSubMenuOpen = true;
        slidingBarElement.css('transform', 'translateX(-100%)');

        slidingMenuSubSubmenuContentElement.html(itemSubmenu.html());

        slidingMenuSubSubmenuContentElement.find('.ws-submenu-wrapper > ul').each(function () {
          // Check amount of items, if too many, add open/close button.
          let maxItems = 6;
          let el = $(this);
          let children = el.children();
          let tooMany = [];
          if (children.length > maxItems) {
            let title = el.parent().parent().find('> a');

            for (let i = maxItems; i < children.length; i++) {
              tooMany.push(children[i]);
            }

            $(tooMany).wrapAll('<div class="tooManyWrapper">');
            let tooManyWrapper = el.find('.tooManyWrapper');
            tooManyWrapper.get(0).style.setProperty('--ws-items-too-many', tooMany.length); // Set through basic JS, as jQuery won't let you do this.

            let tooManyItemsButton = slidingMenuSubSubmenuTooManyItemsButtonTemplate.clone();

            tooManyItemsButton.find('.title').html(title.html());

            tooManyItemsButton
              .click(function () {
                tooManyWrapper.toggleClass('open');
                $(this).toggleClass('open');
                //let interval = setInterval(resizeMenu, 10);
                //setTimeout(function () { clearInterval(interval); }, 5000);
                setTimeout(resizeMenu, 500);
              })
              .appendTo(el)
            ;
          }
        });


        slidingMenuSubSubmenuHeaderElement.html(itemName);
        slidingmenuSubSubmenuCloseTitleElement.html(headerName);

        bindSubSubMenuEvents();
        resizeMenu();
      };

      let closeSub = function () {
        slidingMenuOpen = false;
        slidingSubMenuOpen = false;

        resizeMenu();
      };

      let closeSubSub = function () {
        slidingMenuOpen = true;
        slidingSubMenuOpen = false;

        resizeMenu();
      }


      let initialize = function (menuElementParameter) {
        menuElement = $(menuElementParameter);

        if (menuElement.data('ws-menu')) {
          console.warn('Trying to reinitialize the menu for element. Skipping.', menuElement);
          return;
        }
        menuElement.data('ws-menu', this);


        // Find elements and set to variable.
        openButtonElement = $(opt.openButton);
        navDesktopTopLeft = menuElement.find('.nav-desktop-top-left');
        slidingMenuContainerElement = menuElement.find('.sliding-menu-container');
        slidingBarElement = menuElement.find('.sliding-bar');
        slidingMenuMainElement = slidingBarElement.find('.main');
        navDesktopBottom = slidingMenuMainElement.find('.nav-desktop-bottom');
        slidingMenuSubmenuElement = slidingBarElement.find('.submenu');
        slidingMenuSubmenuCloseElement = slidingMenuSubmenuElement.find('.close');
        slidingmenuSubmenuCloseTitleElement = slidingMenuSubmenuCloseElement.find('.title');
        slidingMenuSubmenuHeaderElement = slidingMenuSubmenuElement.find('.header');
        slidingMenuSubmenuContentElement = slidingMenuSubmenuElement.find('.content');
        slidingMenuSubmenuTooManyItemsButtonTemplate = slidingMenuSubmenuElement.find('.tmpl-tooManyItemsButton').children().first();

        slidingMenuSubSubmenuElement = slidingBarElement.find('.subsubmenu');
        slidingMenuSubSubmenuCloseElement = slidingMenuSubSubmenuElement.find('.close');
        slidingmenuSubSubmenuCloseTitleElement = slidingMenuSubSubmenuCloseElement.find('.title');
        slidingMenuSubSubmenuHeaderElement = slidingMenuSubSubmenuElement.find('.header');
        slidingMenuSubSubmenuContentElement = slidingMenuSubSubmenuElement.find('.content');
        slidingMenuSubSubmenuTooManyItemsButtonTemplate = slidingMenuSubSubmenuElement.find('.tmpl-tooManyItemsButton').children().first();

        bindEvents();

        resizeMenu();
      };

      initialize(this);

      $(window).load(function () {
        resizeMenu();
      });
      $(window).resize(function () {
        resizeMenu();
      });
    });
  };
})(jQuery);
